import { Container, Card, Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import TopBar from '../../components/topBar/TopBar';
import { useMobile } from '@octano/global-ui';
import { CourseInfo } from './parts/CourseInfo';
import { SelectTeacherForm } from './parts/SelectTeacherForm';
import { StartSurveyLoader } from './parts/StartSurveyLoader';

export default function StartSectionSurvey() {
  const { t } = useTranslation();
  const isMobile = useMobile();
  return (
    <>
      <TopBar title={t(`myCourses.surveys.startSurvey.topBarTitle`)} />
      <StartSurveyLoader>
        {(startSurveyData) => {
          return (
            <Container fluid>
              <Card className="py-4 px-4">
                <CourseInfo courseInfo={startSurveyData.sectionDetail} />
                <Row
                  xs={1}
                  lg={2}
                  className="d-flex flex-wrap justify-content-around mb-5"
                  style={{ gap: isMobile ? 12 : 0 }}
                >
                  <Col className="mb-3">
                    <div style={{ fontSize: 16 }}>
                      {t(`myCourses.surveys.startSurvey.description1`)}
                    </div>
                    <div style={{ fontSize: 16 }}>
                      {t(`myCourses.surveys.startSurvey.description2`)}
                    </div>
                  </Col>
                  <Col>
                    <h2 className="text-primary" style={{ fontSize: 20 }}>
                      {startSurveyData.surveyDetail.title}
                    </h2>
                    <SelectTeacherForm teachers={startSurveyData.teachers} />
                  </Col>
                </Row>
              </Card>
            </Container>
          );
        }}
      </StartSurveyLoader>
    </>
  );
}
